import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type PathFinderState = {
  results: any[];
  avoidConstraints: {
    constraint_key: string;
    max_rank: number;
    label?: string;
    mode?: 'up_to' | 'all';
  }[];
};

const initialState: PathFinderState = {
  results: [],
  avoidConstraints: [],
};

export const pathFinderSlice = createSlice({
  name: 'pathFinder',
  initialState,
  reducers: {
    setResults(state, action: PayloadAction<any[]>) {
      state.results = action.payload ?? [];
    },
    clearResults(state) {
      state.results = [];
    },
    addAvoidConstraint(
      state,
      action: PayloadAction<{
        constraint_key: string;
        max_rank: number;
        label?: string;
        mode?: 'up_to' | 'all';
      }>,
    ) {
      const { constraint_key, max_rank, label, mode = 'up_to' } =
        action.payload || ({} as any);
      if (!constraint_key || typeof max_rank !== 'number') return;
      const idx = state.avoidConstraints.findIndex(
        (x) =>
          x.constraint_key === constraint_key &&
          x.max_rank === max_rank &&
          (x.mode ?? 'up_to') === mode,
      );
      if (idx === -1) {
        state.avoidConstraints.push({ constraint_key, max_rank, label, mode });
      } else if (label && !state.avoidConstraints[idx].label) {
        state.avoidConstraints[idx].label = label;
      }
    },
    removeAvoidConstraint(
      state,
      action: PayloadAction<{
        constraint_key: string;
        max_rank?: number;
        mode?: 'up_to' | 'all';
      }>,
    ) {
      const { constraint_key, max_rank, mode } = action.payload || ({} as any);
      state.avoidConstraints = state.avoidConstraints.filter((x) => {
        if (!constraint_key) return true;
        if (max_rank == null) {
          if (!mode) return x.constraint_key !== constraint_key;
          return !(
            x.constraint_key === constraint_key &&
            (x.mode ?? 'up_to') === mode
          );
        }
        if (!mode) {
          return !(x.constraint_key === constraint_key && x.max_rank === max_rank);
        }
        return !(
          x.constraint_key === constraint_key &&
          x.max_rank === max_rank &&
          (x.mode ?? 'up_to') === mode
        );
      });
    },
    clearAvoidConstraints(state) {
      state.avoidConstraints = [];
    },
  },
});

export const pathFinderActions = pathFinderSlice.actions;
export const pathFinderReducer = pathFinderSlice.reducer;
